module.exports = __webpack_public_path__ + "static/media/panis_2.6e01c588.jpg";